import { Badge } from '@mui/material';
import { ThemeProvider, styled } from '@mui/material/styles';

import { primaryTheme } from '../../utils/theme';
import { FORTA_ERROR } from '../../utils/colors';

interface AlertIconProps {
  badge?: number;
  width?: string;
  height?: string;
  viewBox?: string;
}

const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    marginTop: -1,
    marginRight: 5,
    fontWeight: 700,
    backgroundColor: FORTA_ERROR,
  },
}));

const AlertIcon = (props: AlertIconProps) => {
  const { badge, width = '36', height = '40', viewBox = '0 0 36 40' } = props;

  return (
    <ThemeProvider theme={primaryTheme}>
      <StyledBadge
        badgeContent={badge}
        color={'secondary'}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <svg
          width={width}
          height={height}
          viewBox={viewBox}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.0997 35.0444C24.0997 37.1569 22.4652 38.8875 20.3918 39.0404L20.0927 39.0514H16.0858C13.9733 39.0514 12.2427 37.4169 12.0898 35.3435L12.0788 35.0444H24.0997ZM18.0897 0.985046C25.6738 0.985046 31.8519 7.00512 32.106 14.5274L32.1141 15.0095V22.5505L35.7645 29.8516C36.4623 31.2472 35.5291 32.8773 34.0234 33.0294L33.7934 33.041H2.3858C0.825516 33.041 -0.215277 31.4772 0.322053 30.0625L0.414621 29.8516L4.06511 22.5505V15.0095C4.06511 7.26402 10.3441 0.985046 18.0897 0.985046Z"
            fill="#124E78"
          />
        </svg>
      </StyledBadge>
    </ThemeProvider>
  );
};

export default AlertIcon;
